import toArray from './toArray';
/**
 * Sums the items in the enumerable using the selector
 * @param selector selector to return the number to be summed
 */
export default function sum(enumerable, selector) {
    return toArray(enumerable.select((item) => selector(item))).reduce((a, c) => a + c, 0);
}
